/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer">;
    readonly " $refType": "LocalReplyListContainer_viewer";
};
export type LocalReplyListContainer_viewer$data = LocalReplyListContainer_viewer;
export type LocalReplyListContainer_viewer$key = {
    readonly " $data"?: LocalReplyListContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocalReplyListContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'df6f5775eaa619df572702c19c736d0f';
export default node;
